export const siteInfo = {
  siteName: '4399漫画网',
  siteUrl: 'http://chigua52.cn/',
  siteDescription: '4399漫画网凭借快速的加载技术，让您免费下拉式阅读《健身教练漫画》等海量漫画，享受极速翻页的畅快体验。',
  siteKeywords: '4399漫画,下拉式阅读,免费漫画,漫画在线阅读,健身教练漫画',
  foundedYear: '2012',
  totalComics: '120000',
  dailyVisits: '3500000',
  partners: '680',
  email: 'hello@chigua52.cn',
  phone: '400-888-4399',
  address: '广东省广州市天河区体育西路189号城建大厦28层',
};

export const categories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'action', name: '热血动作', slug: 'action' },
  { id: 'romance', name: '恋爱言情', slug: 'romance' },
  { id: 'comedy', name: '搞笑日常', slug: 'comedy' },
  { id: 'fantasy', name: '玄幻奇幻', slug: 'fantasy' },
  { id: 'horror', name: '悬疑惊悚', slug: 'horror' },
  { id: 'sports', name: '运动竞技', slug: 'sports' },
  { id: 'scifi', name: '科幻未来', slug: 'scifi' },
  { id: 'history', name: '历史古风', slug: 'history' },
];

export const mangas = [
  {
    id: 1,
    title: '健身教练',
    author: '陈大明',
    category: 'sports',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20style%2C%20muscular%20fitness%20trainer%20male%20character%20in%20dynamic%20pose%2C%20gym%20background%2C%20Japanese%20manga%20illustration%20with%20bold%20linework%2C%20warm%20color%20palette%20orange%20and%20red%20accents%2C%20action%20manga%20cover%20design%20with%20dramatic%20lighting%2C%20clean%20white%20background&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    description: '曾经是举重冠军的李浩，因伤退役后成为一名健身教练。面对形形色色的学员，他用自己的专业知识和人生经历，帮助他们实现身体与心灵的双重蜕变。一部热血与温情并存的都市运动漫画。',
    chapters: 248,
    status: '连载中',
    rating: 9.6,
    views: '2.8亿',
    latestChapter: '第248话 新的开始',
    updatedAt: '2026-07-08',
    featured: true,
    chapters_list: [
      { id: 248, title: '第248话 新的开始', date: '2026-07-08' },
      { id: 247, title: '第247话 最后的试炼', date: '2026-07-01' },
      { id: 246, title: '第246话 突破极限', date: '2026-06-24' },
      { id: 245, title: '第245话 团队的羁绊', date: '2026-06-17' },
      { id: 244, title: '第244话 新的挑战者', date: '2026-06-10' },
      { id: 243, title: '第243话 暗流涌动', date: '2026-06-03' },
      { id: 242, title: '第242话 决心', date: '2026-05-27' },
      { id: 241, title: '第241话 健身房危机', date: '2026-05-20' },
      { id: 240, title: '第240话 深夜特训', date: '2026-05-13' },
      { id: 239, title: '第239话 老对手', date: '2026-05-06' },
    ],
  },
  {
    id: 2,
    title: '斗破苍穹',
    author: '天蚕土豆',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20art%2C%20young%20warrior%20with%20flame%20powers%2C%20ancient%20Chinese%20clothing%2C%20epic%20battle%20pose%2C%20dramatic%20fire%20and%20energy%20effects%2C%20golden%20and%20crimson%20color%20scheme%2C%20wuxia%20cultivation%20theme%2C%20clean%20illustration%20style&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然成了废人。在遭遇种种打击后，他遇到了药老，从此踏上修炼斗气、收复异火的传奇旅程。',
    chapters: 623,
    status: '已完结',
    rating: 9.8,
    views: '18.5亿',
    latestChapter: '第623话 新的巅峰（大结局）',
    updatedAt: '2026-05-20',
    featured: true,
    chapters_list: [
      { id: 623, title: '第623话 新的巅峰（大结局）', date: '2026-05-20' },
      { id: 622, title: '第622话 最终决战（下）', date: '2026-05-13' },
      { id: 621, title: '第621话 最终决战（上）', date: '2026-05-06' },
    ],
  },
  {
    id: 3,
    title: '魔王学院的不适合者',
    author: '秋',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20style%2C%20demon%20king%20character%20with%20horns%20and%20dark%20royal%20attire%2C%20magical%20academy%20setting%2C%20silver%20hair%2C%20fantasy%20magic%20circle%20background%2C%20dark%20elegant%20color%20scheme%20black%20and%20purple%2C%20clean%20illustration&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    description: '暴虐魔王阿诺斯厌倦了永无止境的斗争，为了梦想中的和平世界而转生。然而在转生后的世界里，魔王的血脉被视为"不适合者"，他将在魔法学院中证明自己的实力。',
    chapters: 187,
    status: '连载中',
    rating: 9.4,
    views: '9.2亿',
    latestChapter: '第187话 魔王降临',
    updatedAt: '2026-07-07',
    featured: true,
    chapters_list: [
      { id: 187, title: '第187话 魔王降临', date: '2026-07-07' },
      { id: 186, title: '第186话 神之试炼', date: '2026-06-30' },
      { id: 185, title: '第185话 勇者学院', date: '2026-06-23' },
    ],
  },
  {
    id: 4,
    title: '偷偷藏不住',
    author: '竹已',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Romance%20manhua%20cover%20style%2C%20young%20beautiful%20couple%20in%20school%20uniform%2C%20cherry%20blossom%20petals%20falling%2C%20warm%20pink%20and%20pastel%20color%20palette%2C%20soft%20romantic%20illustration%2C%20Japanese%20shoujo%20manga%20aesthetic%2C%20clean%20simple%20background&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    description: '十三岁的桑稚偷偷喜欢着哥哥的朋友段嘉许，这份暗恋从初中持续到大学。当两人再次相遇，段嘉许终于发现了这个小姑娘藏了多年的秘密。',
    chapters: 156,
    status: '已完结',
    rating: 9.7,
    views: '12.3亿',
    latestChapter: '第156话 藏不住的喜欢（终）',
    updatedAt: '2026-04-15',
    featured: false,
    chapters_list: [
      { id: 156, title: '第156话 藏不住的喜欢（终）', date: '2026-04-15' },
      { id: 155, title: '第155话 告白', date: '2026-04-08' },
      { id: 154, title: '第154话 心动的瞬间', date: '2026-04-01' },
    ],
  },
  {
    id: 5,
    title: '一人之下',
    author: '米二',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20action%20cover%2C%20martial%20arts%20fighter%20with%20supernatural%20qi%20energy%2C%20modern%20urban%20setting%2C%20dynamic%20fighting%20stance%2C%20mystical%20Chinese%20elements%2C%20bold%20ink%20style%20illustration%2C%20green%20and%20gold%20color%20accents&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    description: '普通大学生张楚岚在爷爷的坟墓被盗后，卷入了一场异人世界的纷争。在这个隐藏在现代社会中的异能者世界里，他将揭开自己身世的秘密。',
    chapters: 512,
    status: '连载中',
    rating: 9.5,
    views: '15.7亿',
    latestChapter: '第512话 天师度',
    updatedAt: '2026-07-06',
    featured: true,
    chapters_list: [
      { id: 512, title: '第512话 天师度', date: '2026-07-06' },
      { id: 511, title: '第511话 罗天大醮（下）', date: '2026-06-29' },
      { id: 510, title: '第510话 罗天大醮（中）', date: '2026-06-22' },
    ],
  },
  {
    id: 6,
    title: '整容游戏',
    author: '金丘',
    category: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Thriller%20manhua%20cover%2C%20mysterious%20female%20character%20with%20mask%20half%20revealing%20face%2C%20dark%20atmospheric%20lighting%2C%20horror%20suspense%20theme%2C%20mirror%20reflection%20concept%2C%20cool%20blue%20grey%20tones%2C%20psychological%20thriller%20manga%20style&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    description: '一款名为"整容游戏"的APP出现在女主角的手机上，只要完成指定任务，就能换取完美的容貌。但随着游戏的深入，她发现这个游戏的代价远比想象中可怕。',
    chapters: 98,
    status: '连载中',
    rating: 9.2,
    views: '4.1亿',
    latestChapter: '第98话 最终游戏',
    updatedAt: '2026-07-05',
    featured: false,
    chapters_list: [
      { id: 98, title: '第98话 最终游戏', date: '2026-07-05' },
      { id: 97, title: '第97话 真相浮现', date: '2026-06-28' },
    ],
  },
  {
    id: 7,
    title: '非人哉',
    author: '一汪空气',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Comedy%20slice%20of%20life%20manhua%20cover%2C%20mythological%20creatures%20living%20modern%20life%2C%20nine%20tailed%20fox%20girl%20in%20office%20outfit%2C%20cute%20humorous%20style%2C%20pastel%20colorful%20illustration%2C%20lighthearted%20comedy%20manga%20aesthetic&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    description: '在当代都市中，一群传说中的神仙妖怪们过着普通人的日常生活。九尾狐九月、龙太子敖烈、哪吒等角色在现代社会中闹出各种啼笑皆非的故事。',
    chapters: 420,
    status: '连载中',
    rating: 9.6,
    views: '11.8亿',
    latestChapter: '第420话 龙宫的日常',
    updatedAt: '2026-07-07',
    featured: true,
    chapters_list: [
      { id: 420, title: '第420话 龙宫的日常', date: '2026-07-07' },
      { id: 419, title: '第419话 哪吒的烦恼', date: '2026-06-30' },
    ],
  },
  {
    id: 8,
    title: '星梦偶像计划',
    author: '烟头',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Idol%20star%20manhua%20cover%2C%20beautiful%20female%20idol%20singer%20on%20stage%20with%20spotlight%2C%20glittering%20stage%20performance%2C%20kpop%20inspired%20fashion%2C%20pink%20and%20gold%20sparkle%20effects%2C%20glamorous%20entertainment%20industry%20theme&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    description: '热爱唱歌的普通女孩林星梦，在一次偶然的机会下参加了全国偶像选拔大赛。在追逐梦想的道路上，她遇到了劲敌、也收获了友情与爱情。',
    chapters: 203,
    status: '已完结',
    rating: 9.3,
    views: '7.6亿',
    latestChapter: '第203话 星梦成真（终章）',
    updatedAt: '2026-03-28',
    featured: false,
    chapters_list: [
      { id: 203, title: '第203话 星梦成真（终章）', date: '2026-03-28' },
      { id: 202, title: '第202话 最后的舞台', date: '2026-03-21' },
    ],
  },
  {
    id: 9,
    title: '镇魂街',
    author: '许辰',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Urban%20fantasy%20manhua%20cover%2C%20guardian%20spirit%20warrior%20in%20modern%20street%2C%20ancient%20Chinese%20general%20armor%2C%20supernatural%20elements%2C%20dramatic%20action%20pose%2C%20golden%20and%20crimson%20color%20scheme%2C%20epic%20scale&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    description: '普通大学生夏铃在应聘工作途中误入罗刹街，从此卷入镇魂将与恶灵们的战斗中。在这个连接人界与灵域的镇魂街中，每个人都有自己的守护灵。',
    chapters: 376,
    status: '连载中',
    rating: 9.5,
    views: '10.2亿',
    latestChapter: '第376话 新的守护灵',
    updatedAt: '2026-07-04',
    featured: false,
    chapters_list: [
      { id: 376, title: '第376话 新的守护灵', date: '2026-07-04' },
      { id: 375, title: '第375话 灵域之门', date: '2026-06-27' },
    ],
  },
  {
    id: 10,
    title: '篮球少年',
    author: '于彦舒',
    category: 'sports',
    cover: 'https://readdy.ai/api/search-image?query=Sports%20basketball%20manhua%20cover%2C%20high%20school%20basketball%20player%20dunking%2C%20dynamic%20sports%20action%2C%20sweat%20and%20determination%2C%20court%20background%2C%20energetic%20orange%20and%20blue%20color%20scheme%2C%20inspiring%20sports%20manga%20style&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    description: '身高不足170cm的林峰凭借惊人的弹跳力和球感，在高中篮球界崭露头角。面对质疑与挑战，他用汗水和努力证明：篮球不只是高个子的运动。',
    chapters: 189,
    status: '已完结',
    rating: 9.4,
    views: '6.3亿',
    latestChapter: '第189话 全国大赛（终）',
    updatedAt: '2026-02-14',
    featured: false,
    chapters_list: [
      { id: 189, title: '第189话 全国大赛（终）', date: '2026-02-14' },
      { id: 188, title: '第188话 绝杀', date: '2026-02-07' },
    ],
  },
  {
    id: 11,
    title: '三体',
    author: '刘慈欣（原著）/ 童话',
    category: 'scifi',
    cover: 'https://readdy.ai/api/search-image?query=Sci%20fi%20manhua%20cover%2C%20cosmic%20space%20background%20with%20three%20body%20problem%20concept%2C%20futuristic%20technology%2C%20alien%20civilization%20theme%2C%20deep%20space%20mystery%2C%20dark%20blue%20and%20silver%20color%20scheme%2C%20hard%20science%20fiction%20illustration&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    description: '文化大革命期间，天文学家叶文洁向宇宙发出了地球的第一声啼鸣。四光年外，三体文明正苦苦挣扎，接收到信号后决定入侵地球。人类文明面临前所未有的危机。',
    chapters: 134,
    status: '连载中',
    rating: 9.7,
    views: '8.9亿',
    latestChapter: '第134话 面壁计划',
    updatedAt: '2026-07-03',
    featured: true,
    chapters_list: [
      { id: 134, title: '第134话 面壁计划', date: '2026-07-03' },
      { id: 133, title: '第133话 智子封锁', date: '2026-06-26' },
    ],
  },
  {
    id: 12,
    title: '秦时明月',
    author: '温世仁（原著）/ 孙家裕',
    category: 'history',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20manhua%20cover%2C%20ancient%20warrior%20with%20sword%20in%20Qin%20dynasty%20setting%2C%20traditional%20Chinese%20architecture%2C%20martial%20arts%20theme%2C%20elegant%20ink%20wash%20painting%20style%2C%20golden%20and%20dark%20red%20color%20palette&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    description: '秦始皇统一六国后，项少龙之子天明在乱世中成长。他背负着神秘的身世，在墨家、兵家等诸子百家的纷争中，逐渐揭开自己命运的面纱。',
    chapters: 287,
    status: '连载中',
    rating: 9.4,
    views: '7.8亿',
    latestChapter: '第287话 百家争鸣',
    updatedAt: '2026-07-02',
    featured: false,
    chapters_list: [
      { id: 287, title: '第287话 百家争鸣', date: '2026-07-02' },
      { id: 286, title: '第286话 墨家机关', date: '2026-06-25' },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    role: '忠实读者 · 5年',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20male%20manga%20fan%2C%20simple%20clean%20illustration%2C%20warm%20friendly%20expression%2C%20casual%20outfit%2C%20minimal%20style&width=200&height=200&seq=testimonial-01&orientation=squarish',
    content: '4399漫画的加载速度真的没话说！看《健身教练》下拉式翻页特别流畅，根本不用等。而且完全免费，漫画资源还特别全，每天都有更新，我现在已经是重度用户了。',
    rating: 5,
  },
  {
    id: 2,
    name: '动漫资讯站',
    role: '合作媒体 · 动漫情报局',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20an%20anime%20news%20reporter%20character%2C%20professional%20cute%20look%2C%20microphone%20accessory%2C%20simple%20clean%20illustration&width=200&height=200&seq=testimonial-02&orientation=squarish',
    content: '作为漫画行业的观察者，4399漫画网在正版化和阅读体验上的投入令人印象深刻。下拉式阅读技术的创新，真正解决了移动端看漫画的痛点。',
    rating: 5,
  },
  {
    id: 3,
    name: '漫画家阿杰',
    role: '签约作者 · 《健身教练》',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20manga%20artist%20character%2C%20holding%20drawing%20pen%2C%20creative%20vibe%2C%20simple%20clean%20illustration%2C%20warm%20toned&width=200&height=200&seq=testimonial-03&orientation=squarish',
    content: '4399平台给了我很大的创作自由，编辑团队专业又贴心。读者反馈即时，下拉式阅读让分镜设计更有发挥空间，连载体验非常好。',
    rating: 5,
  },
];

export const chapterPages = [
  'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20page%2C%20fitness%20trainer%20character%20demonstrating%20exercise%20in%20gym%2C%20Japanese%20manga%20style%20screen%20tone%20and%20speed%20lines%2C%20dynamic%20action%20panels%2C%20bold%20linework%2C%20clean%20shojo%20manga%20page%20layout&width=800&height=1200&seq=chapter-page-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Manga%20comic%20page%20black%20and%20white%2C%20two%20characters%20conversation%20scene%20in%20gym%2C%20screen%20tone%20shading%2C%20manga%20panel%20layout%20with%20dialogue%20bubbles%2C%20Japanese%20comic%20style%2C%20detailed%20background&width=800&height=1200&seq=chapter-page-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Manga%20comic%20page%2C%20intense%20weightlifting%20scene%2C%20muscular%20character%20struggling%20with%20barbell%2C%20dramatic%20speed%20lines%20and%20action%20effects%2C%20black%20and%20white%20Japanese%20manga%20style%2C%20detailed%20muscle%20rendering&width=800&height=1200&seq=chapter-page-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Manga%20page%20style%2C%20emotional%20reaction%20closeup%20of%20character%20face%2C%20dramatic%20shading%20with%20screen%20tone%2C%20Japanese%20comic%20black%20and%20white%2C%20shocked%20expression%20with%20speed%20lines%20background&width=800&height=1200&seq=chapter-page-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Comic%20manga%20page%20black%20and%20white%2C%20training%20montage%20scene%20with%20multiple%20small%20panels%2C%20running%20pushups%20jump%20rope%2C%20dynamic%20composition%2C%20Japanese%20manga%20style%20with%20action%20lines&width=800&height=1200&seq=chapter-page-05&orientation=portrait',
];

export const faqs = [
  {
    question: '4399漫画网真的完全免费吗？',
    answer: '是的！4399漫画网始终坚持免费阅读模式，所有漫画均可免费下拉式阅读，无需任何费用。我们通过广告和品牌合作来维持平台运营，让每一位漫画爱好者都能无障碍享受阅读乐趣。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是4399漫画网的特色功能，打开任意漫画章节后，只需像浏览网页一样向下滑动屏幕，漫画就会自动连续加载下一页。无需频繁点击翻页按钮，可以一气呵成地看完整个章节，阅读体验非常流畅。',
  },
  {
    question: '4399漫画网的漫画更新频率是怎样的？',
    answer: '热门连载漫画如《健身教练》《一人之下》等每周固定更新一话，部分作品可做到每周更新两话。每日零点后系统会自动更新当日新章节，您可以关注喜欢的漫画获取更新提醒。',
  },
  {
    question: '支持哪些设备阅读漫画？',
    answer: '4399漫画网采用响应式设计，完美适配电脑、平板和手机。在手机上使用下拉式阅读体验最佳，您也可以在电脑上用鼠标滚轮享受同样的流畅阅读。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过首页顶部的搜索栏输入漫画名称、作者名或关键词来搜索。也可以在分类页面按类型筛选，包括热血动作、恋爱言情、搞笑日常、玄幻奇幻等十余个分类，帮您快速找到感兴趣的漫画。',
  },
  {
    question: '漫画加载太慢怎么办？',
    answer: '4399漫画网采用先进的CDN加速和图片预加载技术，通常情况下漫画可以秒开。如果遇到加载慢的情况，建议检查网络连接，或者尝试切换WiFi/移动网络。我们也在持续优化加载速度。',
  },
];